import React, { Component } from "react"
import { Toast } from "@shopify/app-bridge-react"
import axios from "../../funcs/axios"
import { Card, DisplayText, TextField, Page, PageActions } from "@shopify/polaris"
export default class CreateCoupons extends Component {
    constructor(props) {
        super(props)
        this.state = {
            numberOfCodes: "",
            description: "",
            trialDays: "",
            specificStore: "",
            toast: {
                error: false,
                content: "",
                show: false,
            },
        }
    }

    handleCreate = () => {
        const { description, trialDays, specificStore } = this.state
        let data = {
            description,
            trialDays,
            specificStore
        }
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/save-coupon`, data)
            .then((res) => {
                this.setState({
                    toast: { show: true, content: res.data.msg, error: false },
                })
            })
            .catch((err) => console.log(err))
    }

    render() {
        const { numberOfCodes, description, trialDays, toast, specificStore } = this.state
        return (
            <Page title="Create coupons">
                <Card title="Description" sectioned>
                    <TextField
                        label="Description"
                        value={description}
                        onChange={(value) => this.setState({ description: value })}
                    ></TextField>
                </Card>
                <Card title="Specific stores" sectioned>
                    <TextField
                        label="Coupons limit is only used at specific stores, if you want to add more stores, each store is separated by commas."
                        value={specificStore}
                        onChange={(value) => this.setState({ specificStore: value })}
                    ></TextField>
                </Card>
                <Card title="Value" sectioned>
                    <TextField
                        label="trial days"
                        value={trialDays}
                        type="number"
                        onChange={(value) => this.setState({ trialDays: value })}
                    ></TextField>
                </Card>
                <PageActions
                    primaryAction={{
                        content: "Create",
                        onAction: () => this.handleCreate(),
                    }}
                />
                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </Page>
        )
    }
}
